module.exports = __webpack_public_path__ + "img/sp_article_4.104cd4e2.jpg";